import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { CommonService } from '../common.service';
var LoadingComponent = (function () {
    function LoadingComponent(apiService, commonService, router) {
        this.apiService = apiService;
        this.commonService = commonService;
        this.router = router;
        this.assetsRoute = "../../assets";
    }
    LoadingComponent.prototype.ngOnInit = function () {
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    };
    LoadingComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage();
    };
    return LoadingComponent;
}());
export { LoadingComponent };



// WEBPACK FOOTER //
// ./src/app/loading/loading.component.ts.pre-build-optimizer.js